import cleanedFilename from '~/util/cleanedFilename';

export default {
  WILL_BE_CANCELLED_LINK: `${cleanedFilename(
    __filename,
  )}-will-be-cancelled-link`,
};
